import { toastActions, TOAST_STATUS } from '@leagueplatform/toast-messages';
import { getPartnerAccessToken } from '@leagueplatform/sso-util';
import { downloadBlobAsFile } from '@leagueplatform/web-common';
import {
  DEFAULT_PARTNER_ID,
  BENEFIT_BOOKLET_DOCUMENT_KEY_PARAM,
} from 'common/constants';
import { downloadBenefitBooklet } from '../../api/download-benefit-booklet';
import { logger } from '../logger';

// handles the Live Chat benefit booklet download action
export const handleBenefitBookletDownload = async (
  urlString: string,
): Promise<void> => {
  try {
    const url = new URL(urlString);
    const documentKey = url.searchParams.get(
      BENEFIT_BOOKLET_DOCUMENT_KEY_PARAM,
    );

    if (!documentKey) {
      logger.error(
        `Benefit booklet download: No ${BENEFIT_BOOKLET_DOCUMENT_KEY_PARAM} found in URL`,
        urlString,
      );
      toastActions.add({
        type: TOAST_STATUS.ERROR,
        textId: 'UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG',
      });
      return;
    }

    const partnerAccessToken = await getPartnerAccessToken(DEFAULT_PARTNER_ID);

    if (!partnerAccessToken) {
      logger.error(
        'Benefit booklet download: Failed to get partner access token',
      );
      toastActions.add({
        type: TOAST_STATUS.ERROR,
        textId: 'UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG',
      });
      return;
    }

    const response = await downloadBenefitBooklet(
      partnerAccessToken,
      documentKey,
    );

    if (!response.ok) {
      logger.error(
        'Benefit booklet download: API request failed',
        response.status,
        response.statusText,
      );
      toastActions.add({
        type: TOAST_STATUS.ERROR,
        textId: 'UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG',
      });
      return;
    }

    const blob = await response.blob();
    const filename = 'benefit-booklet.pdf';

    downloadBlobAsFile(blob, filename);

    logger.log('Benefit booklet download: Success');
  } catch (error) {
    logger.error('Benefit booklet download: Unexpected error', error);
    toastActions.add({
      type: TOAST_STATUS.ERROR,
      textId: 'UH_OH_LOOKS_LIKE_SOMETHING_WENT_WRONG',
    });
  }
};
